<script setup lang="ts">
import logoSrc from '../../../../base/src/assets/logo.trans.svg'
import { useI18n } from '../../../../base/src/composables/useI18n'
import { useSiteStore } from '../../../../base/src/stores/site'
import en from '../../locales/en'
import zh from '../../locales/zh'

const { t } = useI18n({ zh, en })
const siteStore = useSiteStore()

const links = [
  { id: 'voice', key: 'muse.intro.footer.voice' },
  { id: 'video', key: 'muse.intro.footer.video' },
  { id: 'ways', key: 'muse.intro.footer.api' },
]

function scrollTo(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
</script>

<template>
  <footer class="border-t border-gray-100 dark:border-gray-800">
    <div class="mx-auto max-w-6xl px-5 py-10 sm:px-8 sm:py-12">
      <div class="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
        <div class="max-w-sm">
          <div class="flex items-center gap-2.5">
            <img :src="logoSrc" class="h-7 w-7 object-contain" alt="" />
            <div class="text-base font-bold tracking-tight">{{ siteStore.displayName }}</div>
          </div>
          <div class="mt-3 text-xs leading-relaxed text-gray-500 dark:text-gray-400">
            {{ siteStore.displayDescription }}
          </div>
        </div>

        <div>
          <div class="text-xs font-semibold uppercase tracking-wide text-gray-400">
            {{ t('muse.intro.footer.product') }}
          </div>
          <div class="mt-3 space-y-2">
            <div
              v-for="link in links"
              :key="link.id"
              class="cursor-pointer text-xs text-gray-500 transition-colors hover:text-primary dark:text-gray-400"
              @click="scrollTo(link.id)"
            >
              {{ t(link.key) }}
            </div>
          </div>
        </div>
      </div>

      <div class="mt-8 border-t border-gray-100 pt-5 text-xs text-gray-400 dark:border-gray-800 dark:text-gray-500">
        {{ t('muse.intro.footer.copyright', { year: new Date().getFullYear(), name: siteStore.displayName }) }}
      </div>
    </div>
  </footer>
</template>
